// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.GetSharedDataResult
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.toDataItem
import org.multipaz.cbor.Bstr

fun GetSharedDataResult.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "_bixHH9VmAkBSbeXwPFW_iU4a3cPrxc2p6qtPteU67Y")
val GetSharedDataResult_cborSchemaId = ByteString(-3, -72, -79, 28, 127, 85, -104, 9, 1, 73, -73, -105, -64, -15, 86, -2, 37, 56, 107, 119, 15, -81, 23, 54, -89, -86, -83, 62, -41, -108, -21, -74)

fun GetSharedDataResult.Companion.fromCbor(data: ByteArray): GetSharedDataResult {
    return GetSharedDataResult.fromDataItem(Cbor.decode(data))
}

val GetSharedDataResult.Companion.cborSchemaId: ByteString
    get() = GetSharedDataResult_cborSchemaId

fun GetSharedDataResult.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("version", this.version.toDataItem())
    builder.put("data", Bstr(this.data.toByteArray()))
    return builder.end().build()
}

fun GetSharedDataResult.Companion.fromDataItem(dataItem: DataItem): GetSharedDataResult {
    val version = dataItem["version"].asNumber
    val data = ByteString(dataItem["data"].asBstr)
    return GetSharedDataResult(
        version = version,
        data = data,
    )
}
